import {
  actions as authActions,
  operations as authOperations,
} from '@saucelabs/sl-container-authentication';
import { actions as permissionsActions } from '@saucelabs/sl-container-permissions';
import { actions as userConcurrencyActions } from '@saucelabs/sl-module-concurrency';
import { actions as userTunnelsActions } from '@saucelabs/sl-module-tunnels';
import { actions as messagesActions } from '@saucelabs/sl-module-messages';
import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import Raven from '@saucelabs/sl-util-sentry';

import * as constants from './constants';

/*
Tries to fetch current user credentials while displaying loading state
in the whole UI, might be extended with other initial data requests
required for application to start.
*/
export const initialize = createApiAction(
  constants.INITIALIZE,
  (payload, meta, dispatch, getState) => (
    dispatch(authActions.getJWTWhoami(null, { skipErrorPage: true }))
      .then(() => {
        dispatch(authOperations.startJWTRefreshLoop());
        return Promise.all([
          dispatch(authActions.getWhoami()),
          dispatch(authActions.getMe()),
          dispatch(permissionsActions.getPermissions()),
          dispatch(messagesActions.getMessages()),
        ]);
      }).then(() => {
        const { user } = getState();
        const username = user.get('username');

        if (user.isAuthenticated()) {
          Raven.setUserContext({
            username,
          });
        }

        return user.get('team_management') ?
          dispatch(authActions.getMeUserService()) :
          Promise.resolve();
      }).then(() => {
        const { user } = getState();
        const username = user.get('username');

        dispatch(userConcurrencyActions.subscribeUser(username));
        dispatch(userConcurrencyActions.subscribeConcurrencies());
        dispatch(userTunnelsActions.subscribeUser(username));
        dispatch(userTunnelsActions.subscribeTunnels());
      })
  ),
);

export const cleanup = createAction(constants.CLEANUP);

export const stop = () => (dispatch) => {
  dispatch(userConcurrencyActions.unsubscribeConcurrencies());
  dispatch(userTunnelsActions.unsubscribeTunnels());
  dispatch(cleanup());
};
